import { BasicTooltip } from "@/components/ui/Tooltip";
import { InviteeOut } from "@/types/workspace-invite";

interface WorkspaceInvitationDisplayProps {
  inviteeData: InviteeOut[];
}

export const WorkspaceInvitationDisplay = ({ inviteeData }: WorkspaceInvitationDisplayProps) => {
  const uniqueOrganizations = Array.from(
    new Set(inviteeData.map(invitee => invitee.organization_name)),
  );
  const isMultipleOrganizations = uniqueOrganizations.length > 1;
  const maxDisplayedWorkspaces = isMultipleOrganizations ? 3 : 6;

  return (
    <div className="space-y-4">
      <p className="text-lg text-gray-700">
        You've been invited to join the following{" "}
        {inviteeData.length > 1 ? "workspaces" : "workspace"} on PromptLayer:
      </p>
      <div className="flex flex-wrap gap-4">
        {uniqueOrganizations.map(orgName => {
          const orgWorkspaces = inviteeData.filter(
            invitee => invitee.organization_name === orgName,
          );

          return (
            <div key={orgName} className="space-y-2">
              <h3 className="text-sm font-medium text-gray-600">{orgName}</h3>
              <div className="flex items-center">
                {orgWorkspaces.slice(0, maxDisplayedWorkspaces).map((invitee, index) => (
                  <BasicTooltip
                    key={invitee.id}
                    content={
                      <span className="flex flex-col gap-1">
                        <span className="font-bold">Organization: {orgName}</span>
                        <span className="font-bold">Workspace: {invitee.workspace_name}</span>
                        <span>Invited by {invitee.inviter_name}</span>
                      </span>
                    }
                  >
                    <div
                      className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-blue-200 bg-blue-100"
                      style={{
                        marginLeft: index > 0 ? "-10px" : "0",
                        zIndex: orgWorkspaces.length - index,
                      }}
                      title={`${invitee.workspace_name} - Invited by ${invitee.inviter_name}`}
                    >
                      <span className="text-center text-xs font-semibold leading-tight text-blue-700">
                        {invitee.workspace_name
                          .split(" ")
                          .map(word => word.charAt(0).toUpperCase())
                          .join("")
                          .slice(0, 3)}
                      </span>
                    </div>
                  </BasicTooltip>
                ))}
                {orgWorkspaces.length > maxDisplayedWorkspaces && (
                  <div
                    style={{
                      marginLeft: "-10px",
                      zIndex: orgWorkspaces.length - maxDisplayedWorkspaces,
                    }}
                    className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-blue-200 bg-blue-100"
                  >
                    <span className="text-center text-xs font-semibold leading-tight text-blue-700">
                      +{orgWorkspaces.length - maxDisplayedWorkspaces}
                    </span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
